module.exports = __webpack_public_path__ + "img/portfolio-task.7247f917.svg";